import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB0lkKIhJ5vDg3VGYARv51WHlpgshLBhg4",
    authDomain: "nimtu-prod.firebaseapp.com",
    databaseURL: "https://nimtu-prod.firebaseio.com",
    projectId: "nimtu-prod",
    storageBucket: "nimtu-prod.appspot.com",
    messagingSenderId: "878086218561",
    appId: "1:878086218561:web:13dd5dfc518810a73537c0",
    measurementId: "G-JLFBB854GQ"
};

firebase.initializeApp(firebaseConfig);

var authToken = false;
var messaging = null;

if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging();

    messaging.onTokenRefresh(() => {
        messaging.getToken().then((refreshedToken) => {
            console.log('Token refresh action');
            // Save token
            saveToken(refreshedToken);
        }).catch((err) => {
            console.log('Unable to retrieve refreshed token: ', err);
        });
    });
}


/*function sendTokenToServer(currentToken) {
    if (!isTokenSentToServer()) {
        console.log('Sending token to server...');
        // TODO(developer): Send the current token to your server.
        setTokenSentToServer(true);
    } else {
        console.log('Token already sent to server so won\'t send it again ' +
            'unless it changes');
    }
}*/

/*function isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1';
}

function setTokenSentToServer(sent) {
    window.localStorage.setItem('sentToServer', sent ? '1' : '0');
}*/

function isMessagingSupported() {
    return firebase.messaging.isSupported();
}

function setAuthToken(token) {
    authToken = token;
}

function saveToken(newToken) {
    const currentToken = window.localStorage.getItem('messagingToken');
    const payload = { token: newToken };

    // if we had a token and its different to the new one, include it in the payload
    // so we know which token we are updating on the server side
    if (currentToken && currentToken != newToken) {
        payload.oldToken = currentToken;
    }

    // we only need to send the token if we haven't perviously saved one or if it
    // has actually changed
    if (!currentToken || currentToken != newToken) {
        if (authToken) {
            //console.log('Proceeding to save token: ', newToken)

            axios.post(process.env.VUE_APP_API_FEED_BASE + '/subscribe',
                payload,
                { headers: { Authorization: `Bearer ${authToken}` } }
            ).then(response => {
                window.localStorage.setItem('messagingToken', newToken)
                console.log('Token saved to localStorage: ', response)
            }).catch((err) => {
                console.log('Error saving token: ', err);
            })
        } else {
            console.log('Error: No authToken available - unable to send token to server');
        }
    } else {
        console.log('Token update not required');
    }
}

async function requestNotificationPermission() {
    if (messaging) {
        messaging.requestPermission().then(() => {
            this.getMessagingToken();
        }).catch((err) => {
            console.log('Unable to get permission to notify: ', err);
        });
    }
}

function getMessagingToken() {
    if (messaging) {
        console.log('Getting messaging token')
        messaging.getToken().then(async (token) => {
            if (token) {
                saveToken(token);
            } /*else {
            console.log('No Instance ID token available. Request permission to generate one');
            requestNotificationPermission();
        }*/
        }).catch(function (err) {
            console.log('An error occurred while retrieving token: ', err);
        });
    }
}

export const notifications = {
    setAuthToken,
    saveToken,
    getMessagingToken,
    isMessagingSupported,
    requestNotificationPermission
}